<template>
  <ModalLarge :title="t('download_call_history')" @close="close">
    <div class="chat-script-download-table">
      <ChatScriptDownloadSearchBar v-model="scriptSearchForm" :counts="scripts.length" @search="searchScripts(false)" />
      <ChatScriptDownloadBoard :scripts="scripts" @update="updateScript" />
    </div>
  </ModalLarge>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import ChatScriptDownloadBoard from '@/components/domains/chat/script-download/ChatScriptDownloadBoard.vue';
import ChatScriptDownloadSearchBar from '@/components/domains/chat/script-download/ChatScriptDownloadSearchBar.vue';
import ModalLarge from '@/components/shared/composite/ModalLarge.vue';
import useChatScripts from '@/composables/domains/chat/useChatScripts';
import { TypeCall } from '@/types/common';

const props = withDefaults(
  defineProps<{
    chatType: TypeCall;
    code?: string;
  }>(),
  {
    chatType: 'GENERAL',
    code: '',
  }
);

const emit = defineEmits<{ close: [] }>();

const { t } = useI18n();

const { limitDateRange, scriptSearchForm, scripts, searchScripts, startPolling, stopPolling, updateScript } =
  useChatScripts();

const initSearchForm = () => {
  scriptSearchForm.value = {
    chatType: props.chatType,
    code: props.code,
    startDate: limitDateRange.value.start,
    endDate: limitDateRange.value.end,
  };
};

const close = () => {
  emit('close');
};

onMounted(async () => {
  initSearchForm();
  await searchScripts(false);
  await startPolling();
});

onUnmounted(() => {
  stopPolling();
});
</script>

<style scoped lang="scss">
.chat-script-download-table {
  width: 100%;
  min-height: 50dvh;
  padding-bottom: 0.5rem;
}
</style>
